import { featureFlagsTracking } from "@/contexts/CdpProvider";
// Import of useThorEvent is only allowed here as this is a wrapper hook
// eslint-disable-next-line no-restricted-imports
import { useThorEvent } from "@aviv-dxp/react-thor";
export const useTrackingEvent = (eventData) => {
    const extendedEventData = {
        ...eventData,
        av_ab_test_variant: featureFlagsTracking,
    };
    return useThorEvent({
        compatibilities: { GA3: false, GA4: true },
        eventData: extendedEventData,
    });
};
